import {phoneInput, PhoneInput} from "./phone/PhoneInput";
import {CompanyInput, tfCompanyInput} from "./company/CompanyInputComponent";

import Price from "./price";
import {priceTickerInput, PriceTickerInput} from "./price-ticker/PriceTickerInputComponent";

export default angular.module("tfApp.components.inputs", [Price])
                      .component(PhoneInput, phoneInput())
                      .component(CompanyInput, tfCompanyInput())
                      .component(PriceTickerInput, priceTickerInput())
                      .name;
